import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { WjInputModule } from '@grapecity/wijmo.angular2.input';
import { KYMW0E00Module } from '../../../commons/kymw0e/kymw0e00/kymw0e00.module';

import { AppCommonsModule } from '../../../commons/app-commons.module';

import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { KYMW1407ImageInfoDetailModule } from './kymw1407-image-info-detail/kymw1407-image-info-detail.module';
import { KYMW1407SearchResultModule } from './kymw1407-search-result/kymw1407-search-result.module';
import { KYMW1407UseImageModule } from './kymw1407-use-image/kymw1407-use-image.module';

import { KYMW1407Component } from './kymw1407.component';
import { GetImageFileUrlService } from './api-services/get-image-file-url.service';
import { GetImageInfoDetailService } from './api-services/get-image-info-detail.service';
import { GetImageListService } from './api-services/get-image-list.service';
import { GetSearchImageListService } from './api-services/get-search-image-list.service';
import { GetUseRecordImageListService } from './api-services/get-use-record-image-list.service';
import { GetUseRecordListService } from './api-services/get-use-record-list.service';
import { RegistUseImageService } from './api-services/regist-use-image.service';
import { UpdateImageInfoService } from './api-services/update-image-info.service';
import { UpdateImageInfoEnabledService } from './api-services/update-image-info-enabled.service';
import { UpdateUseImageService } from './api-services/update-use-image.service';


/**
 * 画像指示画面 モジュール設定クラス
 *
 * @export KYMW1407Module
 * @class KYMW1407Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    WjGridModule,
    WjInputModule,
    KYMW1407ImageInfoDetailModule,
    KYMW1407SearchResultModule,
    KYMW1407UseImageModule,
    KYMW0E00Module,
  ],
  declarations: [
    KYMW1407Component,
  ],
  providers: [
    GetImageFileUrlService,
    GetImageInfoDetailService,
    GetImageListService,
    GetSearchImageListService,
    GetUseRecordImageListService,
    GetUseRecordListService,
    RegistUseImageService,
    UpdateImageInfoService,
    UpdateImageInfoEnabledService,
    UpdateUseImageService,
  ],
})
export class KYMW1407Module {
}
